/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Jobticket_Cancel_Before_OrderInputs */



/**

* @param {Validation_Jobticket_Cancel_Before_OrderInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const validation_jobticket_cancel_before_order = /** @type {((inputs?: Validation_Jobticket_Cancel_Before_OrderInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Jobticket_Cancel_Before_OrderInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Das Kündigungsdatum darf nicht vor dem Bestellungsdatum liegen.")
});